import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDesign = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1860_3715",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1860_3715)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.60737 9.69085L9.53862 7.76772L8.14112 6.3573L7.15862 7.31897L6.4055 6.56584L7.37508 5.58334L5.86383 4.09293L3.94071 6.01605L7.60737 9.69085ZM13.9761 16.0513L15.899 14.1281L14.4295 12.6377L13.4472 13.6073L12.694 12.8542L13.6636 11.8719L12.2405 10.4615L10.3092 12.3927L13.9761 16.0513ZM6.14758 16.5833H3.41675V13.8525L6.84154 10.4488L2.41675 6.01605L5.86383 2.56897L10.2965 6.99355L13.5434 3.73397C13.6588 3.61855 13.7801 3.53682 13.9072 3.48876C14.0342 3.44071 14.1683 3.41668 14.3095 3.41668C14.4504 3.41668 14.5845 3.44071 14.7115 3.48876C14.8388 3.53682 14.96 3.61855 15.0753 3.73397L16.2661 4.94084C16.3815 5.05612 16.4619 5.17737 16.5072 5.30459C16.5526 5.43168 16.5753 5.56571 16.5753 5.70668C16.5753 5.84779 16.5526 5.98189 16.5072 6.10897C16.4619 6.23605 16.3815 6.3573 16.2661 6.47272L13.0145 9.70355L17.4311 14.1363L13.984 17.5833L9.55133 13.1586L6.14758 16.5833ZM4.50008 15.5H5.69883L13.5192 7.67147L12.3286 6.48085L4.50008 14.3013V15.5ZM12.9345 7.05772L12.3286 6.48085L13.5192 7.67147L12.9345 7.05772Z",
			fill: "currentColor"
		})
	})]
});
export default SvgDesign;
